import { Flex, HStack, Box, IconButton, Text } from '@cad-arc';
import { BaseSelect } from '../forms/inputs/base-select';
import { SEARCH_RESULTS_FOOTER_HEIGHT_PX } from './constants';
import { PaginationContextType } from './use-pagination';
import { useApplicationType } from '../common/hooks/use-application-type';

export function SearchResultsFooter({
    pagination,
    results,
}: Readonly<{
    pagination: PaginationContextType;
    results?: unknown[];
}>) {
    const { isFirstResponder } = useApplicationType();
    const fromItem = pagination.itemOffset + 1;
    const toItem = pagination.canGoToNextPage
        ? pagination.itemOffset + pagination.itemsPerPage
        : results
        ? pagination.itemOffset + results.length
        : undefined;
    return (
        <Flex
            w="100%"
            h={`${SEARCH_RESULTS_FOOTER_HEIGHT_PX}px`}
            position="absolute"
            bottom={0}
            padding="0px var(--arc-space-6)"
            justifyContent="space-between"
            alignItems="center"
            flex="1 0 0"
            alignSelf="stretch"
            background="var(--arc-colors-surface-foreground)"
            borderTop="1px solid var(--arc-colors-border-default)"
        >
            <HStack whiteSpace="nowrap">
                <Text>Results Per Page:</Text>
                <Box minW={isFirstResponder ? '80px' : '66px'}>
                    <BaseSelect
                        value={pagination.itemsPerPage}
                        onChange={(e) => pagination.setItemsPerPage(e.target.value)}
                        options={[
                            { label: '25', value: 25 },
                            { label: '50', value: 50 },
                            { label: '75', value: 75 },
                            { label: '100', value: 100 },
                        ]}
                        isClearable={false}
                    />
                </Box>
            </HStack>
            <HStack whiteSpace="nowrap" px="1">
                <Text
                    as="span"
                    color="tertiary"
                    fontWeight="bold"
                >{`${fromItem.toLocaleString()} - ${
                    toItem === undefined ? '?' : toItem.toLocaleString()
                }`}</Text>
                <Text as="span" color="tertiary">{`of ${pagination.totalItemCountDisplay}`}</Text>
            </HStack>
            <HStack>
                <HStack whiteSpace="nowrap">
                    <Text>Page</Text>
                    <Box minW={isFirstResponder ? '80px' : '66px'}>
                        <BaseSelect
                            value={pagination.currentPage}
                            onChange={(e) => pagination.setCurrentPage(e.target.value)}
                            aria-label="current page"
                            options={pagination.pageOptions}
                            isClearable={false}
                        />
                    </Box>
                    <Text>of {pagination.totalPageCountDisplay}</Text>
                </HStack>
                <IconButton
                    variant="ghost"
                    icon="OpenLeft"
                    aria-label="previous page"
                    disabled={!pagination.canGoToPreviousPage}
                    onClick={() => pagination.goToPreviousPage()}
                />
                <IconButton
                    variant="ghost"
                    icon="OpenRight"
                    aria-label="next page"
                    disabled={!pagination.canGoToNextPage}
                    onClick={() => pagination.goToNextPage()}
                />
            </HStack>
        </Flex>
    );
}
